import { Observable } from "rxjs";
import { IReminderListGetQuery, ReminderDeleteCommandResult, ReminderDto, ReminderInitializeCommandResult, ReminderSetCommandResult } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";


export abstract class IReminderService {

  abstract reminderListGet(
    params?: Partial<IReminderListGetQuery>,
    allowCancellation?: boolean | undefined
  ): Observable<ReminderDto[] | undefined>;

  abstract reminderSet(reminder?: ReminderDto | undefined): Observable<ReminderSetCommandResult>;

  abstract reminderInitialize(userNumber: string, customerNumber: string): Observable<ReminderInitializeCommandResult>;

  abstract reminderDelete(userNumber: string): Observable<ReminderDeleteCommandResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IReminderServiceToken = new InjectionToken<IReminderService>('IReminderServiceToken');
